import React, { forwardRef, memo } from 'react'
import { CarouselProvider } from 'pure-react-carousel'
import { CarouselHandle } from './hooks/use-carousel'
import GalleryCarousel from './gallery-carousel'
import GalleryGrid from './gallery-grid'
import { GalleryProps, GalleryLayout } from './types'

const Gallery = forwardRef<CarouselHandle, GalleryProps>(function Gallery(
    {
        header,
        footer,
        images,
        video,
        skipFullScreen = false,
        skipOverlay = false,
        showDots = true,
        showArrows = true,
        showCountTile = true,
        autoPlay = true,
        onSlideChange,
        imageBorder,
        imageBorderRadius,
        layout = GalleryLayout.CAROUSEL,
        onGalleryImageClick,
        onViewAllClick,
        onFullscreenImageClick,
        onFullScreenOpen,
        onOverlayOpen,
        galleryIconSrc,
    },
    parentRef,
) {
    if (layout === GalleryLayout.GRID) {
        return (
            <GalleryGrid
                images={images}
                video={video}
                skipFullScreen={skipFullScreen}
                skipOverlay={skipOverlay}
                imageBorder={imageBorder}
                imageBorderRadius={imageBorderRadius}
                onSlideChange={onSlideChange}
                onGalleryImageClick={onGalleryImageClick}
                onViewAllClick={onViewAllClick}
                onFullscreenImageClick={onFullscreenImageClick}
                onFullScreenOpen={onFullScreenOpen}
                onOverlayOpen={onOverlayOpen}
                header={header}
                footer={footer}
                layout={layout}
                galleryIconSrc={galleryIconSrc}
            />
        )
    }

    // Default carousel layout
    return (
        <CarouselProvider
            naturalSlideWidth={4}
            naturalSlideHeight={3}
            totalSlides={video ? images.length + 1 : images.length}
            dragEnabled
            touchEnabled
            orientation="horizontal"
            isPlaying={autoPlay}
            dragStep={1}
        >
            <GalleryCarousel
                images={images}
                video={video}
                skipFullScreen={skipFullScreen}
                skipOverlay={skipOverlay}
                autoPlay={autoPlay}
                imageBorder={imageBorder}
                imageBorderRadius={imageBorderRadius}
                showArrows={showArrows}
                showDots={showDots}
                parentRef={parentRef}
                showCountTile={showCountTile}
                onSlideChange={onSlideChange}
                onGalleryImageClick={onGalleryImageClick}
                onFullscreenImageClick={onFullscreenImageClick}
                onFullScreenOpen={onFullScreenOpen}
                onOverlayOpen={onOverlayOpen}
                header={header}
                footer={footer}
                layout={layout}
            />
        </CarouselProvider>
    )
})

export default memo(Gallery)
